import { ModalComponents } from '../../../core/Modal'
import { Instructions } from './components'

// TODO make copy dynamic
export const InstructionsPage = () => {
  return (
    <>
      <ModalComponents.HeaderContainer>
        <ModalComponents.Title>Publish your song to this sample pack page.</ModalComponents.Title>
        <ModalComponents.Subtitle>
          Upload a .wav of your song, credit any samples you used, and publish it on the sample pack
          page for new listeners to discover.
        </ModalComponents.Subtitle>
      </ModalComponents.HeaderContainer>
      <ModalComponents.Container>
        <Instructions
          instructions={[
            {
              title: 'Upload a .wav file and credit any samples you used',
              description:
                'Your song will be minted as an NFT with links to credited Arpeggi samples.'
            },
            {
              title: 'Get your song discovered on the sample pack page',
              description:
                'Songs that use samples in this pack will be displayed on the sample pack page for listeners to discover.'
            },
            {
              title: 'Recieve a free NFT of your song',
              description:
                'Your NFT will be automatically dropped to your wallet where you can freely share or sell it.'
            }
          ]}
        />
      </ModalComponents.Container>
    </>
  )
}
